// extracted by mini-css-extract-plugin
export default {"staleContentWarning":"CommentBox-module__staleContentWarning--i6nrw","commentBoxContainer":"CommentBox-module__commentBoxContainer--yrAth"};